// extracted by mini-css-extract-plugin
export default {"employee-container":"BranchCode_employee-container__Y9avm"};